import { Button } from "src/elements";
import { useTranslation } from "src/i18n";
import { useNavigation } from "src/utils/navigation";
import { pages } from "src/utils/pages";

interface Props {
  categoryId: number;
  isDisabled?: boolean;
}

export const CdtTreeButton = ({ categoryId, isDisabled }: Props) => {
  const { navigate } = useNavigation();
  const { t } = useTranslation("common");

  return (
    <Button
      color="greenSmoke"
      variant="inverted"
      size="small"
      isDisabled={isDisabled}
      onClick={() => navigate(pages.categories_categoryId_decisionTrees, { categoryId })}
    >
      {t("cdtTreeEditor.versions.title")}
    </Button>
  );
};
